<script setup lang="ts">
import { ref } from "vue";
import type { Question } from "~/features/python/ch2/exercise/types/exercise.types";

defineProps<{
  question: Question;
  hasSubmitted: boolean;
  isCorrect: boolean | null;
}>();

const showOutput = ref(false);
</script>

<template>
  <section class="rounded-3xl border border-slate-200 bg-slate-50 p-5 shadow-sm">
    <div class="space-y-1">
      <h2 class="text-lg font-semibold text-slate-900">Poora hal</h2>
      <p class="text-sm text-slate-600">
        {{ hasSubmitted ? "Ab araam se har step dekh lo." : "Pehle try karo, phir yeh aur achi tarah samajh aayega." }}
      </p>
    </div>

    <div
      v-if="hasSubmitted && isCorrect !== null"
      class="mt-4 rounded-2xl p-4"
      :class="isCorrect ? 'bg-emerald-50 ring-1 ring-emerald-200' : 'bg-rose-50 ring-1 ring-rose-200'"
    >
      <p class="text-sm font-semibold" :class="isCorrect ? 'text-emerald-700' : 'text-rose-700'">
        {{ isCorrect ? "Bilkul sahi" : "Abhi sahi nahi" }}
      </p>
      <p class="mt-1 text-sm text-slate-700">{{ question.explanation }}</p>
    </div>

    <ol class="mt-4 space-y-3 text-sm text-slate-700">
      <li
        v-for="(step, index) in question.solutionSteps"
        :key="`${question.id}-step-${index + 1}`"
        class="rounded-2xl bg-white p-4 ring-1 ring-slate-200"
      >
        <span class="text-xs font-semibold uppercase tracking-wide text-slate-500">Step {{ index + 1 }}</span>
        <p class="mt-2">{{ step }}</p>
      </li>
    </ol>

    <div v-if="question.code" class="mt-5 rounded-2xl bg-slate-950 p-4 text-slate-100">
      <p class="text-xs font-semibold uppercase tracking-wide text-sky-200">Code</p>
      <pre class="mt-3 overflow-x-auto text-xs leading-6"><code>{{ question.code }}</code></pre>

      <button
        type="button"
        class="mt-4 rounded-full bg-white px-4 py-2 text-sm font-medium text-slate-950"
        @click="showOutput = !showOutput"
      >
        {{ showOutput ? "Output chupao" : "Output dekho" }}
      </button>

      <div v-if="showOutput" class="mt-4 rounded-2xl bg-white/10 p-4">
        <p class="text-xs font-semibold uppercase tracking-wide text-sky-200">Screen par kya ayega</p>
        <p class="mt-2 text-sm font-medium">{{ question.output || question.correct }}</p>
      </div>
    </div>
  </section>
</template>
